module.exports = __webpack_public_path__ + "h5/img/head1.3296de75.png";